// Copyright (c) [2025] [Your Name]
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

import styled from 'styled-components';

export const ChatContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  padding: 10px;
  overflow-x: hidden;
  @media (max-width: 600px) {
    padding: 5px;
    width: 100vw;
  }
`;

export const ChatHeader = styled.h2`
  font-family: 'Arial, sans-serif';
  font-size: 24px;
  font-weight: bold;
  color: #1F2937;
  text-align: center;
  margin-bottom: 10px;
`;

export const ChatCard = styled.div`
  display: flex;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  @media (max-width: 600px) {
    flex-direction: column;
    width: 100%;
    max-width: 100vw;
  }
`;

export const UserList = styled.div`
  width: 200px;
  border-right: 1px solid #E5E7EB;
  @media (max-width: 600px) {
    width: 100%;
    max-height: ${props => (props.$isOpen ? '150px' : '0')};
    overflow-y: auto;
    border-right: none;
    border-top: 1px solid #E5E7EB;
    transition: max-height 0.3s ease;
    display: ${props => (props.$isOpen ? 'block' : 'none')};
  }
`;

export const UserListHeader = styled.div`
  font-family: 'Arial, sans-serif';
  font-size: 16px;
  font-weight: bold;
  color: #1F2937;
  padding: 10px;
  background-color: #F3F4F6;
  @media (max-width: 600px) {
    padding: 8px;
  }
`;

export const UserItem = styled.div`
  font-family: 'Arial, sans-serif';
  font-size: 14px;
  padding: 4px 10px;
  color: ${props => (props.$isBot ? '#10B981' : props.$isCurrentUser ? '#3B82F6' : '#374151')};
  &:hover {
    background-color: #E5E7EB;
  }
  @media (max-width: 600px) {
    padding: 2px 8px;
  }
`;

export const ChatMessages = styled.div`
  flex: 1;
  padding: 10px;
  background-color: #F9FAFB;
  @media (max-width: 600px) {
    padding: 8px;
    width: 100%;
    max-width: calc(100vw - 50px);
  }
`;

export const MessageBubble = styled.div`
  font-family: 'Arial, sans-serif';
  font-size: 14px;
  padding: 8px 12px;
  margin-bottom: 8px;
  border-radius: 8px;
  background-color: ${props => props.$bubbleColor};
  color: ${props => props.$fontColor};
  max-width: 70%;
  align-self: ${props => (props.$isCurrentUser ? 'flex-end' : 'flex-start')};
  ${props => props.$isSystem && `
    background-color: #D1D5DB;
    color: #374151;
    text-align: center;
    max-width: 100%;
  `}
  ${props => props.$isBot && `
    background-color: #D1D5DB;
    color: #000000;
  `}
  @media (max-width: 600px) {
    max-width: 80%;
  }
`;

export const EmoticonContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
`;

export const EmoticonButton = styled.button`
  font-size: 18px;
  padding: 4px;
  border: none;
  background: none;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`;

export const InputField = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid #D1D5DB;
  border-radius: 4px;
  font-family: 'Arial, sans-serif';
  font-size: 14px;
  @media (max-width: 600px) {
    padding: 6px;
  }
`;

export const Button = styled.button`
  padding: 8px 16px;
  border: 1px solid #1F2937;
  border-radius: 4px;
  background-color: #3B82F6;
  color: white;
  font-family: 'Arial, sans-serif';
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background-color: #2563EB;
  }
  @media (max-width: 600px) {
    padding: 6px 12px;
    font-size: 12px;
  }
`;

export const Modal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: 300px;
`;

export const ColorPickerButton = styled.button`
  width: 30px;
  height: 30px;
  border: none;
  background-color: ${props => props.color};
  cursor: pointer;
  border-radius: 50%;
  &:hover {
    opacity: 0.8;
  }
`;